import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLastReadMessagesForThread } from 'store/chat/services/getLastReadMessagesForThread';
import { loadChatUsers } from './loadChatUsers';

export const getLastReadMessagesForThreadThunk = createAsyncThunk(
  'chat/getLastReadMessagesForThread',
  async (_, { getState, dispatch }) => {
    const state = getState();
    const { thread, allUsers, users } = state.chatSlice;
    const threadId = thread.isSubthread
      ? 'subthread'
      : thread.threadId || thread.id;
    const response = await getLastReadMessagesForThread(
      threadId,
      thread.target,
      thread.type
    );

    // Filter out users that are already in users OR allUsers
    const userIds = response.map((msg) => msg.userId);
    const newUserIds = userIds.filter((id) => !users[id] && !allUsers[id]);

    if (newUserIds.length > 0) {
      await dispatch(
        loadChatUsers({
          userIds: newUserIds,
          addToCurrentUsers: true,
        })
      ).then((loadedUsers) => {
        response.forEach((msg) => {
          // Check both loaded users, existing users, and allUsers
          const user =
            loadedUsers.payload[msg.userId] ||
            users[msg.userId] ||
            allUsers[msg.userId];
          if (user) {
            msg.firstName = user.firstName || '';
          }
        });
      });
    } else {
      // All users already exist, just populate firstName from existing data
      response.forEach((msg) => {
        const user = users[msg.userId] || allUsers[msg.userId];
        if (user) {
          msg.firstName = user.firstName || '';
        }
      });
    }

    return response;
  }
);
